/**
 * Permission utility functions for checking user permissions based on role and action
 */

export const checkUserPermissions = (
  permissionName: string,
  userAuthData: any
) => {
  const permissions = userAuthData?.roles?.[0]?.permissions || [];

  // Filter by permission name
  const matchedPermissions = permissions.filter(
    (p: any) => p.permission === permissionName
  );

  return {
    canView: matchedPermissions.some(
      (p: any) =>
        p.rolePermissions?.action === 'VIEW' ||
        p.rolePermissions?.action === 'ALL'
    ),
    canEdit: matchedPermissions.some(
      (p: any) =>
        p.rolePermissions?.action === 'EDIT' ||
        p.rolePermissions?.action === 'ALL'
    ),
    canDelete: matchedPermissions.some(
      (p: any) =>
        p.rolePermissions?.action === 'DELETE' ||
        p.rolePermissions?.action === 'ALL'
    ),
    canCreate: matchedPermissions.some(
      (p: any) =>
        p.rolePermissions?.action === 'CREATE' ||
        p.rolePermissions?.action === 'ALL'
    ),
    actions: matchedPermissions.map((p: any) => p.rolePermissions?.action),
  };
};

export const hasPermissionAction = (
  permissionName: string,
  action: string,
  userAuthData: any
): boolean => {
  const permissions = userAuthData?.roles?.[0]?.permissions || [];
  console.log('permissions', permissions, permissionName, action);
  return permissions.some(
    (p: any) =>
      p.permission === permissionName &&
      (p.rolePermissions?.action === action ||
        p.rolePermissions?.action === 'ALL')
  );
};

export const getAllUserPermissions = (userAuthData: any) => {
  const permissions = userAuthData?.roles?.[0]?.permissions || [];
  return permissions.map((p: any) => ({
    name: p.name,
    permission: p.permission,
    action: p.rolePermissions?.action,
  }));
};
